/* Smart Cart Recommendations — client-side booster.
   Reads the profile JSON emitted by snippets/cart-recs-engine.liquid,
   fetches /recommendations/products.json?intent=complementary per cart item,
   re-scores using the same weights as the Liquid engine, and re-renders the
   top-N cards in the [data-cart-recs-list] slot. Re-runs on cart:updated. */
(function () {
  if (window.__cartRecsBoosterDefined) return;
  window.__cartRecsBoosterDefined = true;

  var WEIGHTS = {
    colorDominant: 100,
    colorSecondary: 40,
    colorMismatch: -200,
    typeComplementary: 80,
    typeSame: -180,
    typeNeutral: 10,
    styleMatch: 90,             /* Same series (Królewski + Królewski) — strongest UX signal */
    icedMatch: 25,
    icedMismatch: -15,
    priceSweet: 40,
    priceAnchor: 25,
    priceTooHigh: -50,
    priceTooLow: -30,
    fsNudge: 60,
    manualOverride: 200,
    lowStock: 15,
    bestseller: 150              /* Aggressive boost — bestsellers dominate among similar candidates */
  };

  var COMPLEMENTARY_MAP = {
    chain:    ['bracelet', 'pendant', 'ring', 'watch'],
    bracelet: ['chain', 'ring', 'watch'],
    ring:     ['chain', 'bracelet'],
    pendant:  ['chain'],
    watch:    ['bracelet', 'chain', 'ring'],
    earring:  ['chain', 'ring'],
    grillz:   ['chain', 'pendant']
  };

  var fetchCache = new Map();
  var SS_TTL_MS = 5 * 60 * 1000;

  // Strip width/length/SKU tokens from a handle to get the "product family core".
  // bransoletka-krolewska-4mm-zloto → bransoletka-krolewska-zloto
  // lancuch-rope-3mm-zloto         → lancuch-rope-zloto
  // Used for anti-cannibalization: don't recommend a 5mm version when cart has the 4mm version.
  function coreHandle(handle) {
    if (!handle) return '';
    return String(handle)
      .toLowerCase()
      .replace(/-\d+(?:[.,]\d+)?-?mm/g, '-')   // -4mm- / -3.5mm-
      .replace(/-\d+(?:[.,]\d+)?mm/g, '-')      // -4mm (end)
      .replace(/-\d+cm/g, '-')                  // -45cm-
      .replace(/-s925\b/g, '-')                 // -s925
      .replace(/-+/g, '-')                       // collapse dashes
      .replace(/(^-|-$)/g, '');                  // trim leading/trailing dash
  }

  function ssGet(key) {
    try {
      var raw = sessionStorage.getItem(key);
      if (!raw) return null;
      var obj = JSON.parse(raw);
      if (!obj || typeof obj.t !== 'number') return null;
      if (Date.now() - obj.t > SS_TTL_MS) return null;
      return obj.d;
    } catch (e) { return null; }
  }

  function ssSet(key, data) {
    try {
      sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), d: data }));
    } catch (e) { /* quota exceeded — ignore */ }
  }

  function normalizeProduct(p) {
    if (!p) return p;
    var primaryVariant = (p.variants && p.variants[0]) || {};
    if (typeof p.tags === 'string') {
      p.tags = p.tags.split(',').map(function (t) { return t.trim(); });
    } else if (!Array.isArray(p.tags)) {
      p.tags = [];
    }
    if (p.price == null && primaryVariant.price != null) p.price = primaryVariant.price;
    if (p.compare_at_price == null && primaryVariant.compare_at_price != null) p.compare_at_price = primaryVariant.compare_at_price;
    if (p.available == null) {
      p.available = !!(p.variants && p.variants.some(function (v) { return v.available; }));
    }
    if (!p.url && p.handle) p.url = '/products/' + p.handle;
    if (!p.featured_image) {
      if (p.images && p.images[0]) {
        p.featured_image = typeof p.images[0] === 'string' ? p.images[0] : (p.images[0].src || '');
      } else if (p.featured_media && p.featured_media.preview_image) {
        p.featured_image = p.featured_media.preview_image.src || '';
      }
    }
    if (!p.product_type && p.type) p.product_type = p.type;
    return p;
  }

  function inferColor(p) {
    var hay = ((p.title || '') + ' ' + (p.handle || '') + ' ' + (p.tags || []).join(' ')).toLowerCase();
    if (hay.indexOf('rose') !== -1) return 'rose';
    var hasGold = hay.indexOf('gold') !== -1 || hay.indexOf('złot') !== -1 || hay.indexOf('zlot') !== -1 || hay.indexOf('żółt') !== -1;
    var hasWhite = hay.indexOf('biał') !== -1 || hay.indexOf('bial') !== -1 || hay.indexOf('white') !== -1;
    var hasSilver = hay.indexOf('silver') !== -1 || hay.indexOf('srebr') !== -1;
    if (hasGold && hasWhite) return 'white-gold';
    if (hasGold) return 'gold';
    if (hasSilver) return 'silver';
    if (hasWhite) return 'white-gold';
    return '';
  }

  function inferType(p) {
    var hay = ((p.title || '') + ' ' + (p.product_type || p.type || '') + ' ' + (p.handle || '')).toLowerCase();
    if (hay.indexOf('bracelet') !== -1 || hay.indexOf('bransolet') !== -1) return 'bracelet';
    if (hay.indexOf('pierścion') !== -1 || hay.indexOf('pierscion') !== -1 || hay.indexOf('pierścień') !== -1 || hay.indexOf('pierscien') !== -1 || /\bring\b/.test(hay)) return 'ring';
    if (hay.indexOf('pendant') !== -1 || hay.indexOf('wisior') !== -1 || hay.indexOf('zawieszk') !== -1) return 'pendant';
    if (hay.indexOf('naszyjnik') !== -1) return 'chain';
    if (hay.indexOf('watch') !== -1 || hay.indexOf('zegarek') !== -1) return 'watch';
    if (hay.indexOf('earring') !== -1 || hay.indexOf('kolczyk') !== -1) return 'earring';
    if (hay.indexOf('grillz') !== -1) return 'grillz';
    return 'chain';
  }

  function inferIced(p) {
    var hay = ((p.title || '') + ' ' + (p.handle || '') + ' ' + (p.tags || []).join(' ')).toLowerCase();
    if (hay.indexOf('iced') !== -1) return true;
    if (hay.indexOf('diamond') !== -1) return true;
    if (hay.indexOf('crystal') !== -1) return true;
    if (hay.indexOf('tennis') !== -1) return true;
    return false;
  }

  function inferStyle(p) {
    var hay = ((p.title || '') + ' ' + (p.handle || '')).toLowerCase();
    if (hay.indexOf('królewsk') !== -1 || hay.indexOf('krolewsk') !== -1 || hay.indexOf('royal') !== -1) return 'królewski';
    if (hay.indexOf('byzantine') !== -1 || hay.indexOf('bizant') !== -1) return 'byzantine';
    if (hay.indexOf('tennis') !== -1) return 'tennis';
    if (hay.indexOf('miami') !== -1 || hay.indexOf('cuban') !== -1) return 'cuban';
    if (hay.indexOf('franco') !== -1) return 'franco';
    if (hay.indexOf('figaro') !== -1) return 'figaro';
    if (hay.indexOf('rope') !== -1) return 'rope';
    if (hay.indexOf('cable') !== -1 || hay.indexOf('ankier') !== -1) return 'cable';
    if (hay.indexOf('box') !== -1) return 'box';
    if (hay.indexOf('moissanit') !== -1) return 'moissanit';
    return '';
  }

  // Classic pendant-friendly chain styles (curated by ICED STUFF: rope/cuban/cable thin chains)
  var PENDANT_FRIENDLY_CHAIN_STYLES = ['rope', 'cuban', 'cable', 'box', 'figaro'];

  function inferWidth(p) {
    var src = ((p.title || '') + ' ' + (p.handle || '')).toLowerCase();
    var m = src.match(/(\d+(?:[.,]\d+)?)\s*mm/);
    return m ? parseFloat(m[1].replace(',', '.')) : 0;
  }

  function priceCents(p) {
    if (typeof p.price === 'number' && p.price > 1000) return p.price;
    var n = parseFloat(p.price);
    if (isNaN(n)) return 0;
    return Math.round(n * 100);
  }

  function compareAtPriceCents(p) {
    if (p.compare_at_price == null) return 0;
    if (typeof p.compare_at_price === 'number' && p.compare_at_price > 1000) return p.compare_at_price;
    var n = parseFloat(p.compare_at_price);
    if (isNaN(n)) return 0;
    return Math.round(n * 100);
  }

  function getComplementaryUnion(cartTypes) {
    var union = {};
    (cartTypes || []).forEach(function (t) {
      var ct = COMPLEMENTARY_MAP[t] || [];
      ct.forEach(function (x) { union[x] = true; });
    });
    return union;
  }

  // Diversify by CANDIDATE type — interleaves bracelets, pendants, rings (signets), watches, etc.
  // Round-robin order follows COMPLEMENTARY_MAP[cartType] priority — for cart=chain that means
  // bracelet (1st) → pendant (2nd) → ring/sygnet (3rd) → watch (4th). Within each type, bestseller first.
  function diversifyByCandidateType(candidates, cartTypes) {
    if (!candidates || candidates.length < 2) return candidates;
    var groups = {};
    candidates.forEach(function (c) {
      var t = c._type || '_other';
      if (!groups[t]) groups[t] = [];
      groups[t].push(c);
    });
    // Sort within each candidate-type group:
    //  1. Bestsellers before non-bestsellers
    //  2. Bestseller-collection POSITION (lower = merchant set as priority)
    //  3. Score descending (style/color/curated matches)
    Object.keys(groups).forEach(function (k) {
      groups[k].sort(function (a, b) {
        if (!!b._isBestseller !== !!a._isBestseller) return (b._isBestseller ? 1 : 0) - (a._isBestseller ? 1 : 0);
        if (a._isBestseller && b._isBestseller) {
          var posA = a._bestsellerPosition != null ? a._bestsellerPosition : 999;
          var posB = b._bestsellerPosition != null ? b._bestsellerPosition : 999;
          if (posA !== posB) return posA - posB; // earlier in collection wins
        }
        return b._score - a._score;
      });
    });

    // Build round-robin order using COMPLEMENTARY_MAP for the dominant cart type.
    // For chain cart → ['bracelet', 'pendant', 'ring', 'watch'] gives the merchant's intended sequence.
    var orderedKeys = [];
    var seen = {};
    (cartTypes || []).forEach(function (ct) {
      var compList = COMPLEMENTARY_MAP[ct] || [];
      compList.forEach(function (k) {
        if (!seen[k] && groups[k] && groups[k].length) {
          orderedKeys.push(k);
          seen[k] = true;
        }
      });
    });
    // Append any remaining types not in the canonical complementary map (earring, grillz, _other)
    Object.keys(groups).forEach(function (k) {
      if (!seen[k]) { orderedKeys.push(k); seen[k] = true; }
    });

    // Round-robin across types in the canonical order
    var maxLen = 0;
    orderedKeys.forEach(function (k) { if (groups[k].length > maxLen) maxLen = groups[k].length; });
    var result = [];
    for (var i = 0; i < maxLen; i++) {
      orderedKeys.forEach(function (t) {
        if (groups[t][i]) result.push(groups[t][i]);
      });
    }
    return result;
  }

  function diversifyByCartType(candidates, cartTypes) {
    if (!cartTypes || cartTypes.length < 2) return candidates;

    var groups = {};
    cartTypes.forEach(function (t) { groups[t] = []; });
    groups['_other'] = [];

    candidates.forEach(function (c) {
      var matched = c._matchedCartType || '';
      if (!matched) {
        for (var i = 0; i < cartTypes.length; i++) {
          var ct = COMPLEMENTARY_MAP[cartTypes[i]] || [];
          if (ct.indexOf(c._type) !== -1) { matched = cartTypes[i]; break; }
        }
        c._matchedCartType = matched;
      }
      if (matched && groups[matched]) groups[matched].push(c);
      else groups['_other'].push(c);
    });

    Object.keys(groups).forEach(function (k) {
      groups[k].sort(function (a, b) { return b._score - a._score; });
    });

    var result = [];
    var maxLen = 0;
    cartTypes.forEach(function (t) { if (groups[t].length > maxLen) maxLen = groups[t].length; });
    for (var i = 0; i < maxLen; i++) {
      cartTypes.forEach(function (t) {
        if (groups[t][i]) result.push(groups[t][i]);
      });
    }
    return result.concat(groups['_other']);
  }

  function scoreCandidate(c, profile) {
    var score = 0;

    // Width-incompatibility — pendant won't fit on chain >4mm and vice versa. Hard reject.
    if (c._width == null) c._width = inferWidth(c);
    if (profile.has_pendant_cart && c._type === 'chain' && c._width > 4) {
      return -1000;
    }
    // Naszyjnik (necklace) for pendant cart = redundant (naszyjnik already has pendant). Reject.
    if (profile.has_pendant_cart) {
      var checkHay = ((c.title || '') + ' ' + (c.handle || '')).toLowerCase();
      if (checkHay.indexOf('naszyjnik') !== -1) return -1000;
    }
    // Charm bracelet in cart (Lucky 777, Onyx, Diamond Cube — bracelets with stones) blocks pendants.
    if (profile.has_charm_bracelet_cart && c._type === 'pendant') {
      return -1000;
    }
    // Merchant exclusion list — products in collection 'bez-zawieszek' shouldn't be recommended for pendant carts
    if (profile.has_pendant_cart && profile.exclude_for_pendant_ids && profile.exclude_for_pendant_ids.length) {
      if (profile.exclude_for_pendant_ids.indexOf(String(c.id)) !== -1) {
        return -1000;
      }
    }

    // Gender filter — explicit women's products (heart/bow/pearl/pink/etc) only when cart has women's item
    var womensHay = ((c.title || '') + ' ' + (c.handle || '') + ' ' + (c.tags || []).join(' ')).toLowerCase();
    var isCandidateWomens = /(heart|serce|kokardka|\bbow\b|pearl|perł|perl|pink|różow|rozow|damsk)/.test(womensHay);
    if (isCandidateWomens && !profile.cart_has_womens) {
      return -1000;
    }
    if (isCandidateWomens && profile.cart_has_womens) {
      score += 50; // boost women's items when cart matches gender
    }
    if (profile.cart_max_chain_width > 4 && c._type === 'pendant') {
      return -1000;
    }

    // bail_size precision — if any cart pendant declared "fits chains ≤Nmm", reject thicker chain candidates
    if (profile.cart_pendant_max_chain_fit > 0 && c._type === 'chain' && c._width > 0 && c._width > profile.cart_pendant_max_chain_fit) {
      return -1000;
    }

    // Anti-cannibalization — don't recommend a near-duplicate of a cart item
    // (e.g. cart has Bransoletka Królewska 4mm Złoto → drop 5mm version of same family).
    if (c._coreHandle && profile.cart_core_handles && profile.cart_core_handles.length) {
      if (profile.cart_core_handles.indexOf(c._coreHandle) !== -1) {
        return -1000;
      }
    }

    if (profile.dominant_color && c._color === profile.dominant_color) {
      score += WEIGHTS.colorDominant;
    } else if (c._color && profile.cart_colors && profile.cart_colors.indexOf(c._color) !== -1) {
      score += WEIGHTS.colorSecondary;
    } else if (c._color && profile.dominant_color) {
      score += WEIGHTS.colorMismatch;
    }

    var cartTypes = profile.cart_types || [profile.dominant_type];
    var compUnion = getComplementaryUnion(cartTypes);
    var isSameType = cartTypes.indexOf(c._type) !== -1;
    var isComplementary = !isSameType && (compUnion[c._type] === true);

    if (isComplementary) {
      score += WEIGHTS.typeComplementary;
      // Priority boost based on position in COMPLEMENTARY_MAP — first entry = strongest pairing
      // (e.g. for chain in cart, bracelet is the canonical pairing → bigger boost than pendant/ring/watch)
      var bestPriorityRank = 0;
      var complementCount = 0;
      cartTypes.forEach(function (t) {
        var ct = COMPLEMENTARY_MAP[t] || [];
        var idx = ct.indexOf(c._type);
        if (idx !== -1) {
          complementCount++;
          var rank = ct.length - idx; // first item → highest rank
          if (rank > bestPriorityRank) bestPriorityRank = rank;
        }
      });
      score += bestPriorityRank * 18; // chain↔bracelet pair: +72; pendant: +54; ring: +36; watch: +18
      if (complementCount > 1) score += 30 * (complementCount - 1);
    } else if (isSameType) {
      score += WEIGHTS.typeSame;
    } else {
      score += WEIGHTS.typeNeutral;
    }

    if (c._style && profile.styles && profile.styles.indexOf(c._style) !== -1) {
      score += WEIGHTS.styleMatch;
    }

    if (profile.is_iced && c._iced) score += WEIGHTS.icedMatch;
    else if (profile.is_iced && !c._iced) score += WEIGHTS.icedMismatch;

    var avg = profile.avg_item_price || 1;
    var pc = priceCents(c);
    var ratio = pc / avg;
    if (ratio >= 0.8 && ratio <= 1.5) score += WEIGHTS.priceSweet;
    else if (ratio > 1.5 && ratio <= 2.0) score += WEIGHTS.priceAnchor;
    else if (ratio > 2.0) score += WEIGHTS.priceTooHigh;
    else if (ratio < 0.5) score += WEIGHTS.priceTooLow;

    if (profile.fs_gap > 0) {
      var minNudge = profile.fs_gap * 0.9;
      var maxNudge = profile.fs_gap * 1.4;
      if (pc >= minNudge && pc <= maxNudge) score += WEIGHTS.fsNudge;
    }

    if (profile.manual_complementary_ids && profile.manual_complementary_ids.indexOf(String(c.id)) !== -1) {
      score += WEIGHTS.manualOverride;
    }
    // Related products metafield — Shopify ML+merchant curated, weaker signal than complementary
    if (profile.manual_related_ids && profile.manual_related_ids.indexOf(String(c.id)) !== -1) {
      score += 60;
    }

    // ── CURATED COMPLEMENTS — domain knowledge from ICED STUFF ──
    // Cart has pendant → boost classic thin chains (Rope/Cuban/Cable 2-4mm) — these pair beautifully
    if (profile.has_pendant_cart && c._type === 'chain') {
      if (c._width >= 2 && c._width <= 4) {
        score += 50; // Strong boost for proper pendant chain width
        if (c._style && PENDANT_FRIENDLY_CHAIN_STYLES.indexOf(c._style) !== -1) {
          score += 50; // Extra boost for classic style (Rope, Cuban, Cable, etc.)
        }
      }
    }
    // Cart has chain → boost matching-style affordable bracelet (entry-tier add-on, e.g. 189zł Królewska)
    if (cartTypes.indexOf('chain') !== -1 && c._type === 'bracelet') {
      var pcCheap = priceCents(c);
      if (pcCheap > 0 && pcCheap <= 20000) { // ≤ 200 zł — affordable add-on (covers 189zł classic)
        score += 50;
      }
      if (c._style && PENDANT_FRIENDLY_CHAIN_STYLES.indexOf(c._style) !== -1) {
        score += 30; // Classic styles tend to match across pieces
      }
    }

    return score;
  }

  function pickReason(c, profile, idx) {
    var i = profile.i18n || {};
    var lang = profile.lang || 'en';
    var rotIdx = (typeof idx === 'number') ? idx : 0;
    var cartTypes = profile.cart_types || [profile.dominant_type];
    var compUnion = getComplementaryUnion(cartTypes);
    var typeNom = (i.type_nom && i.type_nom[c._type]) || '';

    // Use the cart type assigned by diversifyByCartType (so chip matches the round-robin slot)
    var matchedCartType = c._matchedCartType || '';
    if (!matchedCartType) {
      cartTypes.forEach(function (t) {
        var ct = COMPLEMENTARY_MAP[t] || [];
        if (ct.indexOf(c._type) !== -1 && !matchedCartType) matchedCartType = t;
      });
    }
    var cartTypeGen = matchedCartType
      ? (i.type_gen && i.type_gen[matchedCartType]) || ''
      : (i.type_gen && i.type_gen[profile.dominant_type]) || '';

    var styleMatch = !!(c._style && profile.styles && profile.styles.indexOf(c._style) !== -1);
    var isInCart = cartTypes.indexOf(c._type) !== -1;
    var typeComplementary = !isInCart && (compUnion[c._type] === true);
    var hasDominantColor = !!profile.dominant_color;
    var colorMatches = hasDominantColor && c._color === profile.dominant_color;
    var colorMismatch = hasDominantColor && c._color && c._color !== profile.dominant_color;
    var styleCap = c._style ? c._style.charAt(0).toUpperCase() + c._style.slice(1) : '';

    // Manual override
    if (profile.manual_complementary_ids && profile.manual_complementary_ids.indexOf(String(c.id)) !== -1) {
      return i.often_bought || 'Often bought together';
    }

    // FS nudge
    if (profile.fs_gap > 0) {
      var pc = priceCents(c);
      if (pc >= profile.fs_gap * 0.9 && pc <= profile.fs_gap * 1.4) {
        return i.fs_nudge || 'Unlocks free shipping';
      }
    }

    // Strong color mismatch — honest fallback
    if (colorMismatch) {
      return i.often_chosen || 'Frequently chosen together';
    }

    // ── SPECIFIC chip logic — picks the most-precise match reason ──
    var widthUnit = i.width_unit || 'mm';
    var widthPre  = i.width_match_pre || 'Both ';

    // Width match: candidate width matches any width in cart
    var cartWidths = profile.cart_widths || [];
    var widthMatch = false;
    if (c._width && cartWidths.length) {
      for (var wi = 0; wi < cartWidths.length; wi++) {
        if (parseFloat(cartWidths[wi]) === parseFloat(c._width)) { widthMatch = true; break; }
      }
    }

    // Iced match
    var icedMatch = !!(profile.is_iced && c._iced);

    // Specific color chip (only when color truly matches dominant)
    var colorChip = '';
    if (colorMatches) {
      if (c._color === 'gold')        colorChip = i.color_chip_gold || 'Gold';
      else if (c._color === 'white-gold') colorChip = i.color_chip_white_gold || 'White gold';
      else if (c._color === 'silver') colorChip = i.color_chip_silver || 'Silver';
      else if (c._color === 'rose')   colorChip = i.color_chip_rose || 'Rose gold';
    }

    // CHIP — directional "X do Y" for cross-type, color/style for same-type (avoid "Wisior do wisiora")
    var typeNomCand = typeNom;
    var toWord = (i.to || (lang === 'pl' ? 'do ' : 'for your '));

    // SAME TYPE (wisior + wisior) — "Wersja micro" for size sibling, otherwise "Bestseller"
    if (isInCart) {
      var candIsMicro = /micro/i.test((c.title || '') + ' ' + (c.handle || ''));
      if (candIsMicro && !profile.cart_has_micro) {
        return i.micro_version || 'Micro version';
      }
      return i.bestseller_chip || 'Bestseller';
    }

    // CROSS TYPE: "{type_nom} do {cart_type_gen}" e.g. "Bransoletka do łańcucha"
    if (typeNomCand && cartTypeGen) {
      return typeNomCand + ' ' + toWord + cartTypeGen;
    }
    // FALLBACK 1: specific color label
    if (colorChip) {
      return colorChip;
    }
    // FALLBACK 2: premium tier
    if (profile.tier === 'premium') {
      return i.premium_match || 'Premium';
    }
    // FALLBACK 3: color match generic
    if (colorMatches) {
      return colorReasonLabel(profile.dominant_color, i);
    }

    return i.recommended || 'Recommended';
  }

  function colorReasonLabel(color, i) {
    return (i && i.color_match) || 'Color match';
    /* legacy path kept inert below */
    var pre = (i && i.pairs_color_pre) || 'Pairs with ';
    var label;
    if (color === 'gold') label = (i && i.color_gold) || 'gold';
    else if (color === 'white-gold') label = (i && i.color_white_gold) || 'white gold';
    else if (color === 'silver') label = (i && i.color_silver) || 'silver';
    else if (color === 'rose') label = (i && i.color_rose) || 'rose gold';
    else return (i && i.pairs_set) || 'Matching color';
    return pre + label;
  }

  function escapeHtml(s) {
    if (s == null) return '';
    return String(s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function formatMoney(cents) {
    try {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && window.themeVariables && window.themeVariables.shop && window.themeVariables.shop.money_format) {
        return window.Shopify.formatMoney(cents, window.themeVariables.shop.money_format);
      }
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && window.Shopify.money_format) {
        return window.Shopify.formatMoney(cents, window.Shopify.money_format);
      }
    } catch (e) {}
    var n = (cents / 100);
    return n.toFixed(2).replace('.', ',') + ' zł';
  }

  function variantsAttr(variants) {
    if (!variants || !variants.length) return '[]';
    var arr = variants.map(function (v) {
      return {
        id: v.id,
        title: v.title || v.public_title || '',
        available: v.available !== false,
        price: priceCents(v)
      };
    });
    return JSON.stringify(arr).replace(/'/g, '&#39;');
  }

  function renderCardHtml(p, reason, profile) {
    var i = (profile && profile.i18n) || {};
    var img = p.featured_image || (p.featured_media && p.featured_media.preview_image && p.featured_media.preview_image.src) || '';
    var imgSmall = img;
    if (img && img.indexOf('?') === -1 && img.indexOf('//cdn.shopify.com') !== -1) {
      var sep = img.indexOf('?') === -1 ? '?' : '&';
      imgSmall = img + sep + 'width=160';
    }
    var price = priceCents(p);
    var compareAt = compareAtPriceCents(p);
    var scarcityHtml = '';
    var totalInv = 0;
    var unlimited = false;
    if (p.variants) {
      for (var i = 0; i < p.variants.length; i++) {
        var v = p.variants[i];
        if (v.inventory_management == null && v.inventory_policy == null) {
          continue;
        }
        if (v.inventory_quantity != null) totalInv += Math.max(0, v.inventory_quantity);
      }
    }
    if (!unlimited && totalInv > 0 && totalInv <= 3) {
      var sPre = i.low_stock_pre || 'Only ';
      var sPost = i.low_stock_post || ' left';
      scarcityHtml = '<span class="cart-rec-item__scarcity">' + escapeHtml(sPre) + totalInv + escapeHtml(sPost) + '</span>';
    }

    var btnHtml = '<button class="cart-rec-item__btn qap-trigger" type="button" ' +
      'data-product-id="' + p.id + '" ' +
      'data-title="' + escapeHtml(p.title) + '" ' +
      'data-url="' + p.url + '" ' +
      'data-image="' + (img || '') + '" ' +
      'data-price="' + formatMoney(price) + '" ' +
      'data-price-was="' + (compareAt > price ? formatMoney(compareAt) : '') + '" ' +
      "data-variants='" + variantsAttr(p.variants) + "' " +
      'aria-label="Quick add">' +
        '<svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 5v14"/><path d="M5 12h14"/></svg>' +
      '</button>';

    return '' +
      '<div class="cart-rec-item" data-product-id="' + p.id + '">' +
        '<a href="' + p.url + '" class="cart-rec-item__link" aria-label="' + escapeHtml(p.title) + '">' +
          (img ? '<img class="cart-rec-item__img" src="' + imgSmall + '" alt="' + escapeHtml(p.title) + '" loading="lazy">' : '<div class="cart-rec-item__img"></div>') +
          scarcityHtml +
          btnHtml +
        '</a>' +
        (reason
          ? '<span class="cart-rec-item__reason" data-reason>' + escapeHtml(reason) + '</span>'
          : '<span class="cart-rec-item__reason cart-rec-item__reason--empty" data-reason aria-hidden="true">&nbsp;</span>') +
        '<div class="cart-rec-item__price-row">' +
          '<span class="cart-rec-item__price">' + formatMoney(price) + '</span>' +
          (compareAt > price ? '<span class="cart-rec-item__price-was">' + formatMoney(compareAt) + '</span>' : '') +
        '</div>' +
      '</div>';
  }

  function readProfile(wrapper) {
    var script = wrapper.querySelector('[data-cart-recs-profile]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }
  }

  function fetchOne(productId, intent) {
    var url = '/recommendations/products.json?product_id=' + encodeURIComponent(productId) + '&intent=' + intent + '&limit=10';
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (data) { return (data && data.products) || []; })
      .catch(function () { return []; });
  }

  function fetchComplementary(productId) {
    var key = String(productId);
    if (fetchCache.has(key)) return fetchCache.get(key);
    var p = Promise.all([
      fetchOne(productId, 'complementary'),
      fetchOne(productId, 'related')
    ]).then(function (results) {
      var merged = [];
      var seen = {};
      results.forEach(function (arr) {
        arr.forEach(function (prod) {
          var pid = String(prod.id);
          if (!seen[pid]) { seen[pid] = true; merged.push(prod); }
        });
      });
      return merged;
    });
    fetchCache.set(key, p);
    return p;
  }

  function fetchAllProducts() {
    var key = '__catalog__';
    if (fetchCache.has(key)) return fetchCache.get(key);
    var ssKey = 'cartRecs:catalog:v1';
    var cached = ssGet(ssKey);
    if (cached) {
      var resolved = Promise.resolve(cached);
      fetchCache.set(key, resolved);
      return resolved;
    }
    var p = fetch('/products.json?limit=250', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (data) {
        var products = (data && data.products) || [];
        ssSet(ssKey, products);
        return products;
      })
      .catch(function () { return []; });
    fetchCache.set(key, p);
    return p;
  }

  function fetchBestsellers() {
    var key = '__bestsellers__';
    if (fetchCache.has(key)) return fetchCache.get(key);
    var ssKey = 'cartRecs:bestsellers:v1';
    var cached = ssGet(ssKey);
    if (cached) {
      var resolved = Promise.resolve(cached);
      fetchCache.set(key, resolved);
      return resolved;
    }
    var handles = ['bestseller-set', 'best-sellers', 'bestsellers', 'best-selling', 'top-selling', 'frontpage'];
    var attempts = handles.map(function (h) {
      return fetch('/collections/' + h + '/products.json?limit=50', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (data) { return (data && data.products) || []; })
        .catch(function () { return []; });
    });
    var p = Promise.all(attempts).then(function (results) {
      for (var i = 0; i < results.length; i++) {
        if (results[i].length > 0) {
          console.log('[cart-recs] bestseller seed: ' + handles[i] + ' (' + results[i].length + ' products)');
          ssSet(ssKey, results[i]);
          return results[i];
        }
      }
      return [];
    });
    fetchCache.set(key, p);
    return p;
  }

  function setWrapperVisibility(wrapper) {
    var listEl = wrapper.querySelector('[data-cart-recs-list]');
    var empty = !listEl || listEl.children.length === 0;
    if (empty) {
      wrapper.style.display = 'none';
    } else {
      wrapper.removeAttribute('hidden');
      if (wrapper.style.display === 'none') wrapper.style.display = '';
    }
  }

  function boost(wrapper) {
    var profile = readProfile(wrapper);
    console.log('[cart-recs] boost start', { wrapper: wrapper, profile: profile });
    if (!profile || !profile.cart_product_ids || !profile.cart_product_ids.length) {
      console.warn('[cart-recs] no profile or empty cart_product_ids — aborting');
      setWrapperVisibility(wrapper);
      return;
    }

    wrapper.setAttribute('data-cart-recs-debug-profile',
      'dom_color=' + (profile.dominant_color || '?') +
      ' dom_type=' + (profile.dominant_type || '?') +
      ' avg=' + profile.avg_item_price +
      ' iced=' + profile.is_iced +
      ' tier=' + profile.tier +
      ' rendered=' + (profile.rendered_ids ? profile.rendered_ids.length : 0) + '/' + profile.max_recs);

    // STRICT bestsellers-only mode: candidates pool comes EXCLUSIVELY from bestsellers collection.
    // Merchant manages diversity (signets, earrings, pendants, etc.) by curating that collection.
    // Eliminates random catalog products / women's items being recommended for men's carts.
    var bestsellerPromise = fetchBestsellers();
    var allPromises = [bestsellerPromise];

    Promise.all(allPromises).then(function (results) {
      var seen = {};
      profile.cart_product_ids.forEach(function (id) { seen[String(id)] = true; });

      // Build bestseller ID set + POSITION map (lower index = higher merchant priority).
      // Merchant controls order by dragging products in Shopify Admin → Collections → bestseller-set.
      var bestsellerIds = {};
      var bestsellerOrder = {};
      (results[0] || []).forEach(function (p, idx) {
        if (p && p.id != null) {
          bestsellerIds[String(p.id)] = true;
          bestsellerOrder[String(p.id)] = idx;
        }
      });

      var rawCount = 0;
      var candidates = [];
      results.forEach(function (arr) {
        rawCount += arr.length;
        arr.forEach(function (raw) {
          var p = normalizeProduct(raw);
          if (!p || p.available === false) return;
          var pidStr = String(p.id);
          if (seen[pidStr]) return;
          seen[pidStr] = true;
          p._color = inferColor(p);
          p._type = inferType(p);
          p._iced = inferIced(p);
          p._style = inferStyle(p);
          p._coreHandle = coreHandle(p.handle);
          p._isBestseller = !!bestsellerIds[pidStr];
          p._bestsellerPosition = bestsellerOrder.hasOwnProperty(pidStr) ? bestsellerOrder[pidStr] : 999;
          p._score = scoreCandidate(p, profile);
          if (p._isBestseller) {
            // Position-aware boost: position 0 → +200, position 5 → +150, position 20 → +100
            // Merchant controls order in Shopify Admin (drag/drop in collection)
            var posBoost = Math.max(0, WEIGHTS.bestseller - p._bestsellerPosition * 5);
            p._score += WEIGHTS.bestseller + posBoost;
          }
          candidates.push(p);
        });
      });

      console.log('[cart-recs] fetched', rawCount, 'raw across', allPromises.length, 'sources, deduped to', candidates.length, 'candidates');
      wrapper.setAttribute('data-cart-recs-debug-fetch', 'raw=' + rawCount + ' deduped=' + candidates.length + ' sources=' + allPromises.length);

      if (!candidates.length) {
        console.warn('[cart-recs] no candidates after dedupe — keeping Liquid render');
        setWrapperVisibility(wrapper);
        return;
      }
      candidates.sort(function (a, b) { return b._score - a._score; });

      var maxN = profile.max_recs || 4;
      var positives = candidates.filter(function (c) { return c._score > 0; });

      // Round-robin diversify across cart types (so a chain+bracelet cart gets recs for BOTH)
      positives = diversifyByCartType(positives, profile.cart_types || []);
      // Then diversify by CANDIDATE type using COMPLEMENTARY_MAP order:
      // chain cart → bracelet → pendant → ring/sygnet → watch (matches merchant's intended order)
      positives = diversifyByCandidateType(positives, profile.cart_types || []);
      console.log('[cart-recs] positive candidates:', positives.length, 'of', candidates.length, '(diversified by candidate type, bestsellers prioritized)');

      var listEl = wrapper.querySelector('[data-cart-recs-list]');
      if (!listEl) {
        console.error('[cart-recs] list slot not found inside wrapper');
        return;
      }

      // Preserve Liquid-rendered cards (e.g. Brelok / manual override) — append new ones.
      // Mark them so reinit() can later strip JS-appended cards while keeping server output.
      var existingIds = {};
      var existingChildren = listEl.querySelectorAll('[data-product-id]');
      for (var k = 0; k < existingChildren.length; k++) {
        existingChildren[k].setAttribute('data-server-rendered', 'true');
        var pid = existingChildren[k].getAttribute('data-product-id');
        if (pid) existingIds[pid] = true;
      }
      var slotsAvailable = Math.max(0, maxN - existingChildren.length);

      var newCandidates = positives.filter(function (c) { return !existingIds[String(c.id)]; });
      var topN = newCandidates.slice(0, slotsAvailable);
      console.log('[cart-recs] topN scores:', topN.map(function (p) { return p.title + ' (score=' + p._score + ', color=' + p._color + ', type=' + p._type + ')'; }));

      if (!topN.length) {
        console.warn('[cart-recs] nothing new to append — keeping Liquid render as is');
        setWrapperVisibility(wrapper);
        return;
      }

      var headingEl = wrapper.querySelector('[data-cart-recs-heading]');
      if (headingEl && profile.dynamic_heading) {
        headingEl.textContent = profile.dynamic_heading;
      }

      var html = topN.map(function (p, idx) {
        return renderCardHtml(p, pickReason(p, profile, idx), profile);
      }).join('');

      requestAnimationFrame(function () {
        listEl.insertAdjacentHTML('beforeend', html);
        setWrapperVisibility(wrapper);
        console.log('[cart-recs] appended', topN.length, 'cards (total now:', listEl.children.length + ')');
      });
    });
  }

  function isWrapperReady(wrapper) {
    // Cart page context — always boost (visible on load)
    if (wrapper.getAttribute('data-cart-recs-context') === 'page') return true;
    // Drawer context — only boost when drawer is open (defer fetches until user interaction)
    var drawer = wrapper.closest('cart-drawer, [data-cart-drawer], .mini-cart, mini-cart, side-cart');
    if (!drawer) return true;
    if (drawer.hasAttribute('open')) return true;
    if (drawer.classList && (drawer.classList.contains('is-open') || drawer.classList.contains('is-active'))) return true;
    return false;
  }

  function attachDesktopScroll(listEl) {
    if (!listEl || listEl.__scrollWired) return;
    listEl.__scrollWired = true;

    // Mouse-wheel: convert vertical wheel to horizontal scroll on desktop
    listEl.addEventListener('wheel', function (e) {
      // Skip on touch devices (already swipeable)
      if (window.matchMedia && window.matchMedia('(hover: none)').matches) return;
      // If user already scrolling horizontally with shift or trackpad, leave alone
      if (e.deltaX !== 0 && Math.abs(e.deltaX) > Math.abs(e.deltaY)) return;
      if (Math.abs(e.deltaY) < 1) return;
      e.preventDefault();
      listEl.scrollLeft += e.deltaY;
    }, { passive: false });

    // Click-drag scroll for mouse users
    var isDown = false;
    var startX = 0;
    var scrollStart = 0;
    listEl.addEventListener('mousedown', function (e) {
      if (e.target.closest('a, button')) return; // don't hijack clicks on cards
      isDown = true;
      startX = e.pageX;
      scrollStart = listEl.scrollLeft;
    });
    document.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      var dx = e.pageX - startX;
      listEl.scrollLeft = scrollStart - dx;
    });
    document.addEventListener('mouseup', function () { isDown = false; });
    document.addEventListener('mouseleave', function () { isDown = false; });
  }

  function init() {
    var wrappers = document.querySelectorAll('[data-cart-recs]:not([data-cart-recs-boosted])');
    for (var i = 0; i < wrappers.length; i++) {
      if (!isWrapperReady(wrappers[i])) continue;
      wrappers[i].setAttribute('data-cart-recs-boosted', 'true');
      try { boost(wrappers[i]); } catch (e) {}
      var listEl = wrappers[i].querySelector('[data-cart-recs-list]');
      if (listEl) attachDesktopScroll(listEl);
    }
  }

  var initScheduled = false;
  function scheduleInit() {
    if (initScheduled) return;
    initScheduled = true;
    requestAnimationFrame(function () {
      initScheduled = false;
      init();
    });
  }

  var reinitDebounceTimer = null;
  function reinit() {
    // Debounce: collapse rapid-fire cart events (page load often triggers 3+ events) into one render
    if (reinitDebounceTimer) clearTimeout(reinitDebounceTimer);
    reinitDebounceTimer = setTimeout(function () {
      reinitDebounceTimer = null;
      fetchCache.clear();
      var existing = document.querySelectorAll('[data-cart-recs][data-cart-recs-boosted]');
      for (var i = 0; i < existing.length; i++) {
        existing[i].removeAttribute('data-cart-recs-boosted');
        var listEl = existing[i].querySelector('[data-cart-recs-list]');
        if (listEl) {
          var children = listEl.querySelectorAll('[data-product-id]');
          for (var k = 0; k < children.length; k++) {
            if (!children[k].hasAttribute('data-server-rendered')) {
              children[k].parentNode.removeChild(children[k]);
            }
          }
        }
      }
      scheduleInit();
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function ensureRefresh() {
    // Theme drawer (CartDrawer) re-renders mini-cart only on cart:refresh.
    // Some flows (quick-add, line-item remove, qty change) dispatch other events → drawer stale → recs stale.
    // Force a single cart:refresh follow-up so Liquid re-renders fresh state.
    // Skip when bundle promo / another flow already scheduled refresh+open (avoids second drawer animation).
    if (window.__cartRecsRefreshScheduled || window.__bundlePromoDrawerLock) return;
    window.__cartRecsRefreshScheduled = true;
    setTimeout(function () {
      window.__cartRecsRefreshScheduled = false;
      if (window.__bundlePromoDrawerLock) return;
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: { openMiniCart: false }
      }));
    }, 50);
  }

  var refreshDebounceTimer = null;
  function refreshAll() {
    // Debounce — multiple cart events often fire in burst (cart:updated + cart:change + line-item:updated)
    if (refreshDebounceTimer) clearTimeout(refreshDebounceTimer);
    refreshDebounceTimer = setTimeout(function () {
      refreshDebounceTimer = null;
      reinit();
      ensureRefresh();
    }, 200);
  }

  // Listen broadly — themes dispatch different events for add/remove/qty change
  ['cart:updated', 'cart:change', 'line-item:updated', 'cart:add', 'cart:remove', 'ajaxProduct:added'].forEach(function (evt) {
    document.addEventListener(evt, refreshAll);
  });
  document.addEventListener('cart:refresh', reinit);

  // Belt-and-suspenders: intercept fetches to cart-mutation endpoints
  if (window.fetch && !window.__cartRecsFetchWrapped) {
    window.__cartRecsFetchWrapped = true;
    var origFetch = window.fetch;
    window.fetch = function () {
      var url = arguments[0];
      var urlStr = typeof url === 'string' ? url : (url && url.url) || '';
      var isCartMutation = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(urlStr);
      var p = origFetch.apply(this, arguments);
      if (isCartMutation) {
        p.then(function () { setTimeout(refreshAll, 100); }, function () {});
      }
      return p;
    };
  }

  if (typeof MutationObserver !== 'undefined') {
    var observer = new MutationObserver(function (mutations) {
      var found = false;
      for (var i = 0; i < mutations.length && !found; i++) {
        var m = mutations[i];
        // childList — new wrapper inserted
        for (var j = 0; j < m.addedNodes.length && !found; j++) {
          var node = m.addedNodes[j];
          if (!node || node.nodeType !== 1) continue;
          if ((node.matches && node.matches('[data-cart-recs]:not([data-cart-recs-boosted])')) ||
              (node.querySelector && node.querySelector('[data-cart-recs]:not([data-cart-recs-boosted])'))) {
            found = true;
          }
        }
        // attributes — drawer open state changed (lazy-load trigger)
        if (!found && m.type === 'attributes' && (m.attributeName === 'open' || m.attributeName === 'class')) {
          var t = m.target;
          if (t && t.querySelector && t.querySelector('[data-cart-recs]:not([data-cart-recs-boosted])')) {
            found = true;
          }
        }
      }
      if (found) scheduleInit();
    });
    observer.observe(document.body || document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['open', 'class']
    });
  }

  window.CartRecs = { init: init, reinit: reinit };
})();